var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "pushproduct"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [(_vm.showpoform) ? _c('div', {}, [_c('b-card', {
    attrs: {
      "no-body": ""
    }
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('product.addProduct')))]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  })]), _vm._v(" "), (_vm.clientid != '') ? _c('b-tabs', {
    staticClass: "card-header",
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": _vm.$t('printProductDetails.basicInfo'),
      "title-link-class": _vm.linkClass(0)
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('product.merchantId')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addproduct.merchantname),
      expression: "addproduct.merchantname"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab1.merchantname')
    },
    attrs: {
      "name": "merchantid",
      "id": "merchantname",
      "data-vv-scope": "tab1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.addproduct.merchantname = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.merchantPlaceholder')))]), _vm._v(" "), _vm._l((_vm.listMerchantIdData), function(Merchant_obj) {
    return _c('option', {
      domProps: {
        "value": Merchant_obj.merchantid
      }
    }, [_vm._v(_vm._s(Merchant_obj.merchantname))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tab1.merchantid')),
      expression: "errors.has('tab1.merchantid')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('tab1.merchantid')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('product.clientProductId')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        min: 5
      }),
      expression: "{required:true,min:5}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab1.Clientproductid')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.clientProductIdPlaceHolder'),
      "name": "Clientproductid",
      "id": "clientproductid",
      "data-vv-scope": "tab1"
    },
    model: {
      value: (_vm.addproduct.clientproductid),
      callback: function($$v) {
        _vm.addproduct.clientproductid = $$v
      },
      expression: "addproduct.clientproductid"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tab1.Clientproductid')),
      expression: "errors.has('tab1.Clientproductid')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.$t('productPlaceHolder.clientProductIdError')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('orders.eanCode')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min:5'),
      expression: "'min:5'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab1.eancode')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.eanCodePHolder'),
      "name": "eancode",
      "id": "eancode",
      "data-vv-scope": "tab1"
    },
    model: {
      value: (_vm.addproduct.eancode),
      callback: function($$v) {
        _vm.addproduct.eancode = $$v
      },
      expression: "addproduct.eancode"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tab1.eancode')),
      expression: "errors.has('tab1.eancode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('tab1.eancode')) + "\n                    ")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('product.productName')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab1.Productname')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.productNamePlaceHolder'),
      "name": "Productname",
      "id": "Productname",
      "data-vv-scope": "tab1"
    },
    model: {
      value: (_vm.addproduct.productname),
      callback: function($$v) {
        _vm.addproduct.productname = $$v
      },
      expression: "addproduct.productname"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tab1.Productname')),
      expression: "errors.has('tab1.Productname')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('productPlaceHolder.productNameError')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('product.productDescription')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab1.Productdescription')
    },
    attrs: {
      "type": "textarea",
      "placeholder": _vm.$t('productPlaceHolder.productDescriptionPlaceHolder'),
      "name": "Productdescription",
      "id": "Productdescription",
      "data-vv-scope": "tab1"
    },
    model: {
      value: (_vm.addproduct.productdescription),
      callback: function($$v) {
        _vm.addproduct.productdescription = $$v
      },
      expression: "addproduct.productdescription"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tab1.Productdescription')),
      expression: "errors.has('tab1.Productdescription')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('productPlaceHolder.productDescriptionError')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('removeHold.productMrp')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|decimal'),
      expression: "'required|decimal'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab1.Productmrp')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.mrpPlaceHolder'),
      "name": "Productmrp",
      "id": "Productmrp",
      "data-vv-scope": "tab1"
    },
    on: {
      "input": _vm.checkmrp
    },
    model: {
      value: (_vm.addproduct.mrp),
      callback: function($$v) {
        _vm.addproduct.mrp = $$v
      },
      expression: "addproduct.mrp"
    }
  })], 1), _vm._v(" "), (_vm.mrperror) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(this.mrperror) + "\n                    ")]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tab1.Productmrp')),
      expression: "errors.has('tab1.Productmrp')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('productPlaceHolder.mrpError')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('productPlaceHolder.productTaxPlaceHolder')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Producttax')
    },
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('productPlaceHolder.productTaxPlaceHolder'),
      "name": "Producttax",
      "id": "Producttax",
      "data-vv-scope": ""
    },
    model: {
      value: (_vm.addproduct.productTax),
      callback: function($$v) {
        _vm.addproduct.productTax = $$v
      },
      expression: "addproduct.productTax"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Producttax')),
      expression: "errors.has('Producttax')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Producttax')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('productPlaceHolder.productCategory')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cube'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addproduct.productcategoryname),
      expression: "addproduct.productcategoryname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab1.productcategoryname')
    },
    attrs: {
      "name": "productcategoryname",
      "id": "productcategoryname",
      "data-vv-scope": "tab1"
    },
    on: {
      "click": _vm.getSubcategoryList,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.addproduct.productcategoryname = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('client.subCategoryPlaceholder')))]), _vm._v(" "), _vm._l((_vm.listProductcategoryData), function(Category_obj) {
    return _c('option', {
      domProps: {
        "value": Category_obj.productcategory
      }
    }, [_vm._v(_vm._s(Category_obj.productcategory))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tab1.productcategoryname')),
      expression: "errors.has('tab1.productcategoryname')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('productPlaceHolder.productCategoryError')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('product.productSubCategory')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-globe'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addproduct.productsubcategory),
      expression: "addproduct.productsubcategory"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab1.subcategoryname')
    },
    attrs: {
      "name": "subcategoryname",
      "id": "subcategoryname",
      "data-vv-scope": "tab1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.addproduct.productsubcategory = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.productSubCategoryPlaceHolder')))]), _vm._v(" "), _vm._l((_vm.listsubProductcategoryData), function(Category_obj) {
    return _c('option', {
      domProps: {
        "value": Category_obj.productsubcategory
      }
    }, [_vm._v(_vm._s(Category_obj.productsubcategory))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tab1.subcategoryname')),
      expression: "errors.has('tab1.subcategoryname')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('orderreport.productcategoryErrorMessage')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.brand')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab1.Brand')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.brandPlaceHolder'),
      "name": "Brand",
      "id": "Brand",
      "data-vv-scope": "tab1"
    },
    model: {
      value: (_vm.addproduct.brand),
      callback: function($$v) {
        _vm.addproduct.brand = $$v
      },
      expression: "addproduct.brand"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tab1.Brand')),
      expression: "errors.has('tab1.Brand')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('productPlaceHolder.brandError')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('product.productType')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab1.producttype')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.productTypePlaceHolder'),
      "name": "producttype",
      "id": "producttype",
      "data-vv-scope": "tab1"
    },
    model: {
      value: (_vm.addproduct.producttype),
      callback: function($$v) {
        _vm.addproduct.producttype = $$v
      },
      expression: "addproduct.producttype"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tab1.producttype')),
      expression: "errors.has('tab1.producttype')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('tab1.producttype')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('product.table.columns.hsnCode')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab1.HSNcode')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.hsnCodePlaceHolder'),
      "name": "HSNcode",
      "id": "HSNcode",
      "data-vv-scope": "tab1"
    },
    model: {
      value: (_vm.addproduct.hsncode),
      callback: function($$v) {
        _vm.addproduct.hsncode = $$v
      },
      expression: "addproduct.hsncode"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tab1.HSNcode')),
      expression: "errors.has('tab1.HSNcode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('productPlaceHolder.hsnCodeError')) + "\n                    ")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.gstRate')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|decimal'),
      expression: "'required|decimal'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab1.GSTrate')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.gstraratePlaceHolder'),
      "name": "GSTrate",
      "id": "GSTrate",
      "data-vv-scope": "tab1"
    },
    on: {
      "input": _vm.CheckGSTRate
    },
    model: {
      value: (_vm.addproduct.hsnrate),
      callback: function($$v) {
        _vm.addproduct.hsnrate = $$v
      },
      expression: "addproduct.hsnrate"
    }
  })], 1), _vm._v(" "), (_vm.gstRateerror) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(this.gstRateerror))]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tab1.GSTrate')),
      expression: "errors.has('tab1.GSTrate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('productPlaceHolder.gstrarateError')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [(_vm.activemrpflag) ? _c('b-form-fieldset', [_c('label', [_vm._v("Active MRP")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|decimal'),
      expression: "'required|decimal'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab1.activemrp')
    },
    attrs: {
      "type": "number",
      "placeholder": "Enter Active MRP",
      "name": "activemrp",
      "data-vv-scope": "tab1"
    },
    model: {
      value: (_vm.addproduct.activemrp),
      callback: function($$v) {
        _vm.addproduct.activemrp = $$v
      },
      expression: "addproduct.activemrp"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tab1.activemrp')),
      expression: "errors.has('tab1.activemrp')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Enter Active MRP")])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('b-form-fieldset', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addproduct.filetype),
      expression: "addproduct.filetype"
    }],
    attrs: {
      "type": "radio",
      "value": "Upload"
    },
    domProps: {
      "checked": _vm._q(_vm.addproduct.filetype, "Upload")
    },
    on: {
      "__c": function($event) {
        _vm.addproduct.filetype = "Upload"
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('printProductDetails.fileUpload')) + "\n                    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('b-form-fieldset', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addproduct.filetype),
      expression: "addproduct.filetype"
    }],
    attrs: {
      "type": "radio",
      "value": "url"
    },
    domProps: {
      "checked": _vm._q(_vm.addproduct.filetype, "url")
    },
    on: {
      "__c": function($event) {
        _vm.addproduct.filetype = "url"
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('printProductDetails.imageUrl')) + "\n                    ")])], 1), _vm._v(" "), (_vm.addproduct.filetype == 'url') ? _c('div', {
    staticClass: "col-md-7"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.fileUpload')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab1.File Upload')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.fileUploadPlaceholder'),
      "name": "File Upload",
      "id": "File Upload",
      "data-vv-scope": "tab1"
    },
    model: {
      value: (_vm.addproduct.fileupload),
      callback: function($$v) {
        _vm.addproduct.fileupload = $$v
      },
      expression: "addproduct.fileupload"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tab1.File Upload')),
      expression: "errors.has('tab1.File Upload')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('tab1.File Upload')))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.addproduct.filetype == 'Upload') ? _c('div', {
    staticClass: "col-md-7"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('product.productImage')))]), _vm._v(" "), _c('input', {
    ref: "file",
    attrs: {
      "type": "file",
      "id": "Image",
      "value": "",
      "name": "Image",
      "data-vv-scope": "tab1"
    },
    on: {
      "change": function($event) {
        _vm.handleFileUpload()
      }
    }
  }), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveImage('Productimage', 'file')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" " + _vm._s(_vm.$t('product.upload')))])])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "float-right"
  }, [_c('b-button-group', {
    staticClass: "mt-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.validateTab()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.nextBtn'))), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])]), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": _vm.$t('printProductDetails.details'),
      "title-link-class": _vm.linkClass(1)
    },
    on: {
      "click": function($event) {
        _vm.validateTab()
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('div', {
    staticClass: "checkbox"
  }, [_c('b-form-checkbox', {
    staticStyle: {
      "font-weight": "100"
    },
    attrs: {
      "name": "isfragile",
      "value": 1
    },
    model: {
      value: (_vm.addproduct.isfragile),
      callback: function($$v) {
        _vm.addproduct.isfragile = $$v
      },
      expression: "addproduct.isfragile"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.isFragile')))])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('div', {
    staticClass: "checkbox"
  }, [_c('b-form-checkbox', {
    staticStyle: {
      "font-weight": "100"
    },
    attrs: {
      "name": "isflammable",
      "value": 1
    },
    model: {
      value: (_vm.addproduct.isflammable),
      callback: function($$v) {
        _vm.addproduct.isflammable = $$v
      },
      expression: "addproduct.isflammable"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.isflammable')))])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('b-form-checkbox', {
    staticStyle: {
      "font-weight": "100"
    },
    attrs: {
      "name": "isliquid",
      "value": 1
    },
    model: {
      value: (_vm.addproduct.isliquid),
      callback: function($$v) {
        _vm.addproduct.isliquid = $$v
      },
      expression: "addproduct.isliquid"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.isLiquid')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('b-form-checkbox', {
    staticStyle: {
      "font-weight": "100"
    },
    attrs: {
      "name": "istempsensitive",
      "value": 1
    },
    on: {
      "change": _vm.temsensitiveChange
    },
    model: {
      value: (_vm.addproduct.istempsensitive),
      callback: function($$v) {
        _vm.addproduct.istempsensitive = $$v
      },
      expression: "addproduct.istempsensitive"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.isTempSensitive')))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('div', {
    staticClass: "checkbox"
  }, [_c('b-form-checkbox', {
    staticStyle: {
      "font-weight": "100"
    },
    attrs: {
      "name": "serializecontrol",
      "value": 1
    },
    model: {
      value: (_vm.addproduct.serializecontrol),
      callback: function($$v) {
        _vm.addproduct.serializecontrol = $$v
      },
      expression: "addproduct.serializecontrol"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.serializeControl')))])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('div', {
    staticClass: "checkbox"
  }, [_c('b-form-checkbox', {
    staticStyle: {
      "font-weight": "100"
    },
    attrs: {
      "name": "ishazardous",
      "value": 1
    },
    model: {
      value: (_vm.addproduct.ishazardous),
      callback: function($$v) {
        _vm.addproduct.ishazardous = $$v
      },
      expression: "addproduct.ishazardous"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.isHazardous')))])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('div', {
    staticClass: "checkbox"
  }, [_c('b-form-checkbox', {
    staticStyle: {
      "font-weight": "100"
    },
    attrs: {
      "name": "isSerialcontrol",
      "value": 1
    },
    model: {
      value: (_vm.addproduct.isSerialcontrol),
      callback: function($$v) {
        _vm.addproduct.isSerialcontrol = $$v
      },
      expression: "addproduct.isSerialcontrol"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('printProductDetails.isSerialcontrol')))])], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('div', {
    staticClass: "checkbox"
  }, [_c('b-form-checkbox', {
    staticStyle: {
      "font-weight": "100"
    },
    attrs: {
      "name": "lotcontrBrandol",
      "value": 1
    },
    model: {
      value: (_vm.addproduct.lotcontrol),
      callback: function($$v) {
        _vm.addproduct.lotcontrol = $$v
      },
      expression: "addproduct.lotcontrol"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.isLotcontrol')))])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('div', {
    staticClass: "checkbox"
  }, [_c('b-form-checkbox', {
    staticStyle: {
      "font-weight": "100"
    },
    attrs: {
      "name": "expirycontrolled",
      "value": 1
    },
    model: {
      value: (_vm.addproduct.expirycontrolled),
      callback: function($$v) {
        _vm.addproduct.expirycontrolled = $$v
      },
      expression: "addproduct.expirycontrolled"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.expiryControlled')))])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('div', {
    staticClass: "checkbox"
  }, [_c('b-form-checkbox', {
    staticStyle: {
      "font-weight": "100"
    },
    attrs: {
      "name": "ismrptracked",
      "value": 1
    },
    model: {
      value: (_vm.ismrptracked),
      callback: function($$v) {
        _vm.ismrptracked = $$v
      },
      expression: "ismrptracked"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.isMRPTracked')))])], 1)])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.addproduct.istempsensitive) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.minTemp')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-thermometer'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|decimal'),
      expression: "'required|decimal'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Mintemp')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('unicommerceProduct.minTempPlaceholder'),
      "name": "Mintemp",
      "id": "Mintemp"
    },
    model: {
      value: (_vm.addproduct.mintemp),
      callback: function($$v) {
        _vm.addproduct.mintemp = $$v
      },
      expression: "addproduct.mintemp"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Mintemp')),
      expression: "errors.has('Mintemp')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Mintemp')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.maxTemp')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-thermometer'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|decimal'),
      expression: "'required|decimal'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Max Temp')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('unicommerceProduct.maxTempPlaceholder'),
      "name": "Max Temp",
      "id": "Max Temp"
    },
    on: {
      "keyup": _vm.Checktemp
    },
    model: {
      value: (_vm.addproduct.maxtemp),
      callback: function($$v) {
        _vm.addproduct.maxtemp = $$v
      },
      expression: "addproduct.maxtemp"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Max Temp')),
      expression: "errors.has('Max Temp')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Max Temp')))]), _vm._v(" "), (_vm.isError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.Qtyerrors))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.uomTemp')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-thermometer'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|'),
      expression: "'required|'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('UOMtemp')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('unicommerceProduct.UOMTempPlaceholder'),
      "name": "UOMtemp",
      "id": "UOMtemp"
    },
    model: {
      value: (_vm.addproduct.uomtemp),
      callback: function($$v) {
        _vm.addproduct.uomtemp = $$v
      },
      expression: "addproduct.uomtemp"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('UOMtemp')),
      expression: "errors.has('UOMtemp')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('UOMtemp')) + "\n                    ")])], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.shelfLifeDuration')))]), (_vm.addproduct.expirycontrolled == 1) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.addproduct.nocontrol == 1 ? 'required|numeric' : ''),
      expression: "  addproduct.nocontrol==1 ? 'required|numeric' : '' "
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Shelflifeduration')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.shelfLifeDurationPlaceHolder'),
      "name": "Shelflifeduration",
      "id": "Shelflifeduration"
    },
    on: {
      "keyup": _vm.lifeuom
    },
    model: {
      value: (_vm.addproduct.shelflifeduration),
      callback: function($$v) {
        _vm.addproduct.shelflifeduration = $$v
      },
      expression: "addproduct.shelflifeduration"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Shelflifeduration')),
      expression: "errors.has('Shelflifeduration')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Shelflifeduration')) + "\n                    ")]), _vm._v(" "), (_vm.isshelflifeError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.Shelflifeduration) + "\n                    ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.primaryUom')))]), (_vm.addproduct.nocontrol == 1) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-balance-scale'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.addproduct.nocontrol == 1 ? 'required' : ''),
      expression: "  addproduct.nocontrol==1 ? 'required' : '' "
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Primaryuom')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.primaryUomPlaceHolder'),
      "name": "Primaryuom",
      "id": "Primaryuom"
    },
    model: {
      value: (_vm.addproduct.primaryuom),
      callback: function($$v) {
        _vm.addproduct.primaryuom = $$v
      },
      expression: "addproduct.primaryuom"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Primaryuom')),
      expression: "errors.has('Primaryuom')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Primaryuom')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.secondaryUom')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-file'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('Secondaryuom')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.secondaryUomPlaceHolder'),
      "name": "Secondaryuom",
      "id": "Secondaryuom"
    },
    model: {
      value: (_vm.addproduct.secondaryuom),
      callback: function($$v) {
        _vm.addproduct.secondaryuom = $$v
      },
      expression: "addproduct.secondaryuom"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Secondaryuom')),
      expression: "errors.has('Secondaryuom')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Secondaryuom')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" " + _vm._s(_vm.$t('printProductDetails.unitDimensonUom')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-balance-scale'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('decimal'),
      expression: "'decimal'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('UnitDimensonuom')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.unitDimensonUomPlaceHolder'),
      "id": "UnitDimensonuom"
    },
    model: {
      value: (_vm.addproduct.unitdimensonuom),
      callback: function($$v) {
        _vm.addproduct.unitdimensonuom = $$v
      },
      expression: "addproduct.unitdimensonuom"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('UnitDimensonuom')),
      expression: "errors.has('UnitDimensonuom')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('UnitDimensonuom')) + "\n                    ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.unitWeight')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-balance-scale'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        decimal: true,
        required: true,
        min_value: 0
      }),
      expression: "{decimal:true,required:true,min_value:0}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Unitweight')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.unitWeightPlaceHolder'),
      "name": "Unitweight",
      "id": "Unitweight"
    },
    model: {
      value: (_vm.addproduct.unitweight),
      callback: function($$v) {
        _vm.addproduct.unitweight = $$v
      },
      expression: "addproduct.unitweight"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Unitweight')),
      expression: "errors.has('Unitweight')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('productPlaceHolder.unitWeightError')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.unitLength')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-balance-scale'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        decimal: true,
        min_value: 0,
        required: true
      }),
      expression: "{decimal:true,min_value:0,required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Unitlength')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.unitLengthPlaceHolder'),
      "name": "Unitlength",
      "id": "Unitlength"
    },
    model: {
      value: (_vm.addproduct.unitlength),
      callback: function($$v) {
        _vm.addproduct.unitlength = $$v
      },
      expression: "addproduct.unitlength"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Unitlength')),
      expression: "errors.has('Unitlength')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('productPlaceHolder.unitlengthError')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.unitBreadth')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-balance-scale'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        decimal: true,
        min_value: 0,
        required: true
      }),
      expression: "{decimal:true,min_value:0,required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Unitbreadth')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.unitBreadthPlaceHolder'),
      "name": "Unitbreadth",
      "id": "Unitbreadth"
    },
    model: {
      value: (_vm.addproduct.unitbreadth),
      callback: function($$v) {
        _vm.addproduct.unitbreadth = $$v
      },
      expression: "addproduct.unitbreadth"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Unitbreadth')),
      expression: "errors.has('Unitbreadth')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('productPlaceHolder.unitBreadthError')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.unitHeight')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        decimal: true,
        min_value: 0,
        required: true
      }),
      expression: "{decimal:true,min_value:0,required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Unitheight')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.unitHeightPlaceHolder'),
      "name": "Unitheight",
      "id": "Unitheight"
    },
    model: {
      value: (_vm.addproduct.unitheight),
      callback: function($$v) {
        _vm.addproduct.unitheight = $$v
      },
      expression: "addproduct.unitheight"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Unitheight')),
      expression: "errors.has('Unitheight')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('productPlaceHolder.unitHeightError')) + "\n                    ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.mfgCode')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-envelope'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (''),
      expression: "''"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('MFGcode')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.mfgCodePlaceHolder'),
      "name": "MFGcode",
      "id": "MFGcode"
    },
    model: {
      value: (_vm.addproduct.mfgcode),
      callback: function($$v) {
        _vm.addproduct.mfgcode = $$v
      },
      expression: "addproduct.mfgcode"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('MFGcode')),
      expression: "errors.has('MFGcode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('MFGcode')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.attribute1')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('attribute1')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.attribute1PlaceHolder'),
      "name": "attribute1",
      "id": "attribute1"
    },
    model: {
      value: (_vm.addproduct.attribute1),
      callback: function($$v) {
        _vm.addproduct.attribute1 = $$v
      },
      expression: "addproduct.attribute1"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('attribute1')),
      expression: "errors.has('attribute1')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('attribute1')) + "\n                    ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.stickerName')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('stickername')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.stickerNamePlaceHolder'),
      "name": "stickername",
      "id": "stickername"
    },
    model: {
      value: (_vm.addproduct.stickername),
      callback: function($$v) {
        _vm.addproduct.stickername = $$v
      },
      expression: "addproduct.stickername"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('stickername')),
      expression: "errors.has('stickername')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('stickername')) + "\n                    ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.subBrand')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('subbrand')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.subBrandPlaceHolder'),
      "name": "subbrand",
      "id": "subbrand"
    },
    model: {
      value: (_vm.addproduct.subbrand),
      callback: function($$v) {
        _vm.addproduct.subbrand = $$v
      },
      expression: "addproduct.subbrand"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('subbrand')),
      expression: "errors.has('subbrand')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('subbrand')) + "\n                    ")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.size')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-arrows'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('size')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.sizePlaceHolder'),
      "name": "size",
      "id": "size"
    },
    model: {
      value: (_vm.addproduct.size),
      callback: function($$v) {
        _vm.addproduct.size = $$v
      },
      expression: "addproduct.size"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('size')),
      expression: "errors.has('size')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('size')) + "\n                    ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.color')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-file'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('color')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.colorPlaceHolder'),
      "name": "color",
      "id": "color"
    },
    model: {
      value: (_vm.addproduct.color),
      callback: function($$v) {
        _vm.addproduct.color = $$v
      },
      expression: "addproduct.color"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('color')),
      expression: "errors.has('color')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('color')) + "\n                    ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.velocityCode')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('velocitycode')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.velocityCodePlaceHolder'),
      "name": "velocitycode",
      "id": "velocitycode"
    },
    model: {
      value: (_vm.addproduct.velocitycode),
      callback: function($$v) {
        _vm.addproduct.velocitycode = $$v
      },
      expression: "addproduct.velocitycode"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('velocitycode')),
      expression: "errors.has('velocitycode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('velocitycode')) + "\n                    ")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.unitPrice')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-file'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('unitprice')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.unitPricePlaceHolder'),
      "name": "unitprice",
      "id": "unitprice"
    },
    model: {
      value: (_vm.addproduct.unitprice),
      callback: function($$v) {
        _vm.addproduct.unitprice = $$v
      },
      expression: "addproduct.unitprice"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('unitprice')),
      expression: "errors.has('unitprice')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('productPlaceHolder.unitPriceError')) + "\n                        ")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('div', {
    staticClass: "col-md-1 clientfooter"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    class: {
      disabled: _vm.disableButton
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveProduct
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.saveBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetform
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.$t('printProductDetails.cancel')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "float-left"
  }, [_c('b-button-group', {
    staticClass: "mt-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.tabIndex = 0
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v(" " + _vm._s(_vm.$t('printProductDetails.previous')))])]), _vm._v(" "), _c('br')], 1)])], 1) : _vm._e()], 1)])], 1) : _vm._e()])])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0dcd608c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0dcd608c","hasScoped":true}!./src/views/components/pushProduct/pushProduct.component.html
// module id = 1432
// module chunks = 0